import React, { useState, useEffect } from "react";
import ConfLeftPanel from "./authConf/confLeftPanel";
import SignInComponent from "./authConf/signInComponent";
import Favicon from "../../images/faviconwhite.png";
import Guest from "./authConf/Guest";
import { useNavigate } from "react-router-dom";
import useIsMobile from "../../hooks/useIsMobile";

const Login = () => {
  const navigate = useNavigate();
  const [guest, setGuest] = useState(false);
  const [show, setShow] = useState(false);
  const isMobile = useIsMobile();
  useEffect(() => {
    const roomId = localStorage.getItem("roomId");
    console.log("roomId", roomId);
    if (roomId) {
      setGuest(true);
    }
    if (localStorage.getItem("token")) {
      navigate("/dashboard");
    } else {
      setShow(true);
    }
  }, []);

  return (
    <>
      {show && (
        <div
          className="w-full min-h-screen"
          style={{
            backgroundImage: `url(/purpleDarkGradientBg.svg)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="py-4 border-b border-slate-700 flex items-center justify-between">
            <img src={Favicon} alt="R-Link" className="h-10 w-auto ml-3" />
            <div className="flex items-center gap-2 mr-4"></div>
          </div>
          <div
            className={`flex justify-center ${
              isMobile ? "h-[100vh]" : "h-[90vh]"
            } w-full pt-[1%]`}
          >
            <div className="sm:w-[90%] md:w-[80%] sm:rounded-2xl md:rounded-4xl overflow-hidden flex flex-col lg:flex-row">
              <ConfLeftPanel />
              {!guest && <SignInComponent />}
              {guest && <Guest onHostsLoginClick={() => setGuest(false)} />}

              {/* <SignInComponent /> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
